<div [formGroup]="locationDetailsFormGroup">

  <hr>

    <div class="form-row">
      <div class="col-md-4">
        <label class="h6" for="addressSearchInput" translate>Location</label>
      </div>

      <div class="col">
        @if (addressIsSelected) {
          <label class="h6" for="addressSearchInput" translate>Address</label>
        }
        @if (coordinatesIsSelected) {
          <label class="h6" for="addressSearchInput" translate>Coordinates (lat x long)
          </label>
        }
      </div>
      <div class="col-auto">
      </div>
    </div>

    <div class="form-row">

      <!-- ADDRESS/COORDINATES SWITCH-->
      <div class="col-md-4">
        <div class="btn-group w-100">
          <button (click)="setLocationDetailsType(locationDetailsTypes.ADDRESS)" type="button"
            class="btn" [ngClass]="addressIsSelected ? 'btn-primary' : 'btn-outline-primary'">
            <span class="fa-solid fa-table-cells mr-1"></span><span translate>Address</span>
          </button>
          <button (click)="setLocationDetailsType(locationDetailsTypes.COORDINATES)" type="button"
            class="btn" [ngClass]="coordinatesIsSelected ? 'btn-primary' : 'btn-outline-primary'">
            <span class="fa-solid fa-list mr-1"></span><span translate>Coordinates</span>
          </button>
        </div>
      </div>

      <!--ADDRESS / COORDINATES INPUTS-->
      <div class="col">
        <div class="form-group">
          <input #addressSearchInput [hidden]="!addressIsSelected" class="form-control"
            formControlName="addressSearchInput" id="addressSearchInput" name="addressSearchInput"
            placeholder="{{ 'Enter address' | translate }}" type="text">
            <div [hidden]="!coordinatesIsSelected" class="form-row">
              <div class="col">
                <input [ngClass]="{ 'is-invalid': formControls.latitudeSearchInput.errors }" class="form-control"
                  formControlName="latitudeSearchInput" id="latitudeSearchInput" name="latitudeSearchInput"
                  placeholder="{{ 'Enter latitude' | translate }}"
                  type="number">
                  @if (formControls.latitudeSearchInput.errors) {
                    <div class="invalid-feedback">
                      @if (formControls.latitudeSearchInput.errors.min) {
                        <span><span
                        translate>Min value is</span> {{LATITUDE_MIN}}
                      °</span>
                    }
                    @if (formControls.latitudeSearchInput.errors.max) {
                      <span><span
                      translate>Max value is</span> {{LATITUDE_MAX}}
                    °</span>
                  }
                </div>
              }
            </div>
            <div class="col">
              <input [ngClass]="{ 'is-invalid': formControls.longitudeSearchInput.errors }" class="form-control"
                formControlName="longitudeSearchInput" id="longitudeSearchInput" name="longitudeSearchInput"
                placeholder="{{ 'Enter longitude' | translate }}"
                type="number">
                @if (formControls.longitudeSearchInput.errors) {
                  <div class="invalid-feedback">
                    @if (formControls.longitudeSearchInput.errors.min) {
                      <span><span
                      translate>Min value is</span> {{LONGITUDE_MIN}}°</span>
                    }
                    @if (formControls.longitudeSearchInput.errors.max) {
                      <span><span
                      translate>Max value is</span> {{LONGITUDE_MAX}}°</span>
                    }
                  </div>
                }
              </div>
            </div>

          </div>
        </div>

        <!-- SEARCH AREA-->
        <div class="col-auto">
          <button (click)="onSearch()" class="btn btn-outline-primary" type="button" [disabled]="!isAdminOrHigher">
            <span class="fa-solid fa-magnifying-glass"></span>
            @if (isSearchStarted) {
              <span class="fa-solid fa-gear fa-spin"></span>
            }
          </button>
        </div>
      </div>

      <div class="google-map-container mb-2">
        <google-map (mapClick)="onMapClick($event)" [center]="mapSettings.center"
          [mapTypeId]="mapSettings.mapDisplayType"
          [options]="mapSettings.options"
          [zoom]="mapSettings.zoom"
          height="300px"
          width="100%">
          @for (marker of mapSettings.markers; track marker) {
            <map-marker
              [options]="mapSettings.markerOptions"
              [position]="marker">
            </map-marker>
          }

        </google-map>
      </div>


      <!-- Address form fields -->
      <div>
        <div class="card mt-2">
          <div class="card-header">
            <div class="row align-items-center">
              <div class="col">
                <span class="card-title" translate>Address form</span>
              </div>
              <div class="col-auto">
                <button (click)="collapse.toggle()" [attr.aria-expanded]="!isDetailsAreaCollapsed"
                  aria-controls="collapseExample"
                  class="btn btn-sm btn-outline-primary"
                  type="button">
                  @if (isDetailsAreaCollapsed) {
                    <span [innerHTML]="'Show address'|translate"></span>
                  }
                  @if (!isDetailsAreaCollapsed) {
                    <span [innerHTML]="'Hide address'|translate"></span>
                  }
                </button>
              </div>
            </div>
          </div>
          <div #collapse="ngbCollapse" [(ngbCollapse)]="isDetailsAreaCollapsed" class="card-body">
            <div class="form-row">
              <!-- STREET -->
              <div class="col-12 col-lg-4">
                <div class="form-group">
                  <label for="street" translate>Street</label>
                  <input (ngModelChange)="onInputValueChanged()"
                    [ngClass]="{ 'is-invalid': submitted && formControls.street.errors }" class="form-control"
                    formControlName="street" id="street"
                    name="street"
                    type="text">
                  </div>
                </div>

                <!-- NUMBER -->
                <div class="col-12 col-lg-2">
                  <div class="form-group">
                    <label for="number" translate>Number</label>
                    <input (ngModelChange)="onInputValueChanged()"
                      [ngClass]="{ 'is-invalid': submitted && formControls.number.errors }" class="form-control"
                      formControlName="number" id="number"
                      name="number"
                      type="text">
                    </div>
                  </div>

                  <!-- COUNTRY -->
                  <div class="col-12 col-lg-4">
                    <div class="form-group">
                      <label for="country" translate>Country</label>
                      <input (ngModelChange)="onInputValueChanged()"
                        [ngClass]="{ 'is-invalid': submitted && formControls.country.errors && selectedLocationDetailsType===locationDetailsTypes.ADDRESS }"
                        class="form-control"
                        formControlName="country" id="country"
                        name="country"
                        type="text">
                        @if (submitted && formControls.country.errors && selectedLocationDetailsType===locationDetailsTypes.ADDRESS) {
                          <div
                            class="invalid-feedback">
                            @if (formControls.country.errors.required) {
                              <span translate>Country required</span>
                            }
                          </div>
                        }
                      </div>
                    </div>

                    <!--COUNTRY CODE-->
                    <div class="col-12 col-lg-2">
                      <div class="form-group">
                        <label for="country" translate>Country Code</label>
                        <input (ngModelChange)="onInputValueChanged()"
                          [ngClass]="{ 'is-invalid': submitted && formControls.countryCode.errors && selectedLocationDetailsType===locationDetailsTypes.ADDRESS }"
                          class="form-control"
                          formControlName="countryCode" id="countryCode"
                          name="country"
                          type="text">
                          @if (submitted && formControls.countryCode.errors && selectedLocationDetailsType===locationDetailsTypes.ADDRESS) {
                            <div
                              class="invalid-feedback">
                              @if (formControls.countryCode.errors.required) {
                                <span translate>Country Code required</span>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>

                    <div class="form-row">
                      <!-- ZIP CODE -->
                      <div class="col-12 col-lg-2">
                        <div class="form-group">
                          <label for="postalCode" translate>Zip</label>
                          <input (ngModelChange)="onInputValueChanged()"
                            [ngClass]="{ 'is-invalid': submitted && formControls.postalCode.errors }" class="form-control"
                            formControlName="postalCode" id="postalCode"
                            name="postalCode"
                            type="text">
                          </div>
                        </div>

                        <!-- CITY/REGION -->
                        <div class="col-12 col-lg-4">
                          <div class="form-group">
                            <label for="regionCity" translate>City/Region</label>
                            <input (ngModelChange)="onInputValueChanged()"
                              [ngClass]="{ 'is-invalid': submitted && formControls.regionCity.errors && selectedLocationDetailsType===locationDetailsTypes.ADDRESS }"
                              class="form-control"
                              formControlName="regionCity" id="regionCity"
                              name="regionCity"
                              type="text">
                              @if (submitted && formControls.regionCity.errors && selectedLocationDetailsType===locationDetailsTypes.ADDRESS) {
                                <div
                                  class="invalid-feedback">
                                  @if (formControls.regionCity.errors.required) {
                                    <span translate>City/Region required</span>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                          <!-- LATITUDE -->
                          <div class="col-12 col-lg-3">
                            <div class="form-group">
                              <label for="latitude" translate>Latitude</label>
                              <input (ngModelChange)="onInputValueChanged()"
                                [ngClass]="{ 'is-invalid': submitted && formControls.latitude.errors && selectedLocationDetailsType===locationDetailsTypes.COORDINATES }"
                                class="form-control"
                                formControlName="latitude" id="latitude"
                                name="latitude"
                                placeholder="E.g. 48.79035" type="number">
                                @if (submitted && formControls.latitude.errors && selectedLocationDetailsType===locationDetailsTypes.COORDINATES) {
                                  <div
                                    class="invalid-feedback">
                                    @if (formControls.latitude.errors.required) {
                                      <span translate>Latitude required</span>
                                    }
                                    @if (formControls.latitude.errors.min) {
                                      <span><span translate>Min value is</span> {{LATITUDE_MIN}}
                                    °</span>
                                  }
                                  @if (formControls.latitude.errors.max) {
                                    <span><span translate>Max value is</span> {{LATITUDE_MAX}}
                                  °</span>
                                }
                              </div>
                            }
                          </div>
                        </div>

                        <!-- LONGITUDE -->
                        <div class="col-12 col-lg-3">
                          <div class="form-group">
                            <label for="longitude" translate>Longitude</label>
                            <input (ngModelChange)="onInputValueChanged()"
                              [ngClass]="{ 'is-invalid': submitted && formControls.longitude.errors && selectedLocationDetailsType===locationDetailsTypes.COORDINATES }"
                              class="form-control"
                              formControlName="longitude" id="longitude"
                              name="longitude"
                              placeholder="E.g. 9.15470"
                              type="number">
                              @if (submitted && formControls.longitude.errors && selectedLocationDetailsType===locationDetailsTypes.COORDINATES) {
                                <div
                                  class="invalid-feedback">
                                  @if (formControls.longitude.errors.required) {
                                    <span translate>Longitude required</span>
                                  }
                                  @if (formControls.longitude.errors.min) {
                                    <span><span translate>Min value is</span> {{LONGITUDE_MIN}}
                                  °</span>
                                }
                                @if (formControls.longitude.errors.max) {
                                  <span><span translate>Max value is</span> {{LONGITUDE_MAX}}
                                °</span>
                              }
                            </div>
                          }
                        </div>
                      </div>


                    </div>

                  </div>
                </div>
              </div>
            </div>
